export default "__VITE_PUBLIC_ASSET__10264fef__"